/**
 * CacheKeys — Enum key cache dùng cho MISA Cache
 * Dùng khi gọi cache.get(CacheKeys.ROLE_LOCAL)
 * CreatedBy: dbhuan (2026-06-09)
 * UpdatedBy: dbhuan (2026-06-16) — them AUTH_CONFIG, MISA_AUTH_CONFIG cho getAuthConfig
 */
export const CacheKeys = {
  /** Vai trò người dùng — localStorage */
  ROLE_LOCAL: "role_local",
  /** Merchant hiện tại — localStorage */
  CURRENT_MERCHANT: "current_merchant",
  /** Trạng thái merchant — localStorage */
  MERCHANT_STATUS: "merchant_status",
  /** Auth token — localStorage */
  TOKEN: "token",
  /** Thông tin user — localStorage */
  USER: "user",
  /** MISA ID user info (TTL 24h) — localStorage */
  MISA_CURRENT_USER: "misa_current_user",
  /** Loại đăng nhập (JETPAYID/MISAID_V2) — localStorage */
  LOGIN_PROVIDER: "login_provider",
  /** AMIS Platform session ID — localStorage */
  AMPL_SID: "ampl_sid",
  /** Thông tin merchant/tenant — localStorage */
  MERCHANT_INFO: "merchant_info",
  /** Provider đăng nhập lần cuối — localStorage, không xóa khi logout */
  LAST_LOGIN_PROVIDER: "last_login_provider",
  /** Trạng thái collapse sidebar — sessionStorage */
  MENU_COLLAPSE: "menu_collapse",
  /** Auth config cho JETPAYID — localStorage */
  AUTH_CONFIG: "auth_config",
  /** Auth config cho MISAID_V2 — localStorage */
  MISA_AUTH_CONFIG: "misa_auth_config",
};
